module.exports = __webpack_public_path__ + "img/nav01_h.fb141784.png";